<p-toast></p-toast>

<!--p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
-->
<div class="page">
  <div class="header-action">
    <button class="btn-primary" (click)="openModal()">
      + Ajouter une caisse / boutique
    </button>
  </div>

   <!-- ================= MODAL CRÉATION CAISSE / BOUTIQUE ================= -->
  <div class="modal" [class.show]="showModal">
    <div class="ck-panel">

      <div class="ck-head">
        <div>
          <h2 class="ck-title">Ajouter une caisse / boutique</h2>
          <p class="ck-sub">Créez un nouveau point de vente rattaché à votre compte.</p>
        </div>
        <button type="button" class="ck-close" (click)="closeModal()" aria-label="Fermer">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
      </div>

      <form (ngSubmit)="addKid()" #kidForm="ngForm">
        <div class="ck-body">

          <!-- Type -->
          <div class="ck-field">
            <span class="ck-label">Type *</span>
            <div class="ck-types" role="radiogroup">
              <button type="button" role="radio" class="ck-type"
                [class.is-selected]="newKid.mode === 'Boutique'"
                [attr.aria-checked]="newKid.mode === 'Boutique'"
                (click)="newKid.mode = 'Boutique'; errorMessage = ''">
                <span class="ck-type-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7"></path><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path><path d="M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4"></path><path d="M2 7h20"></path></svg>
                </span>
                <span class="ck-type-text">
                  <strong>Boutique</strong>
                  <small>Point de vente avec ses propres accès</small>
                </span>
                <span class="ck-radio"></span>
              </button>

              <button type="button" role="radio" class="ck-type"
                [class.is-selected]="newKid.mode === 'Caisse'"
                [attr.aria-checked]="newKid.mode === 'Caisse'"
                (click)="newKid.mode = 'Caisse'; errorMessage = ''">
                <span class="ck-type-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="5" width="20" height="14" rx="2"></rect><line x1="2" y1="10" x2="22" y2="10"></line><line x1="6" y1="15" x2="10" y2="15"></line></svg>
                </span>
                <span class="ck-type-text">
                  <strong>Caisse</strong>
                  <small>Poste d'encaissement</small>
                </span>
                <span class="ck-radio"></span>
              </button>
            </div>
          </div>

          <!-- Infos générales -->
          <div class="ck-grid">
            <div class="ck-field">
              <label class="ck-label" for="ck-name">Nom <span class="ck-optional">(optionnel)</span></label>
              <input id="ck-name" class="ck-input" type="text" [(ngModel)]="newKid.name" name="name"
                     placeholder="Ex : Boutique Plateau" (input)="errorMessage = ''" />
            </div>
            <div class="ck-field">
              <label class="ck-label" for="ck-address">Adresse <span class="ck-optional">(optionnel)</span></label>
              <input id="ck-address" class="ck-input" type="text" [(ngModel)]="newKid.address" name="address"
                     placeholder="Ex : Avenue Hassan II, Dakar" />
            </div>
          </div>

          <!-- Responsable -->
          <div class="ck-section">
            <p class="ck-section-title">Contact du responsable <span class="ck-optional">(optionnel)</span></p>

            <div class="ck-field">
              <label class="ck-label" for="ck-resp">Nom du responsable</label>
              <input id="ck-resp" class="ck-input" type="text" [(ngModel)]="newKid.responsibleName" name="responsibleName"
                     placeholder="Prénom et nom" />
            </div>

            <div class="ck-grid">
              <div class="ck-field">
                <label class="ck-label" for="ck-email">Email</label>
                <input id="ck-email" class="ck-input" type="email" [(ngModel)]="newKid.email" name="email"
                       placeholder="nom@exemple.com" />
              </div>
              <div class="ck-field">
                <label class="ck-label" for="ck-phone">Téléphone</label>
                <input id="ck-phone" class="ck-input" type="tel" [(ngModel)]="newKid.phone" name="phone"
                       placeholder="77 123 45 67" />
              </div>
            </div>
          </div>

          <div class="ck-error" *ngIf="errorMessage">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
            {{ errorMessage }}
          </div>
        </div>

        <div class="ck-foot">
          <span class="ck-hint" *ngIf="!newKid.mode">Choisissez un type pour continuer</span>
          <button type="button" class="tp-btn-secondary" (click)="closeModal()">Annuler</button>
          <button type="submit" class="tp-btn-primary" [disabled]="!newKid.mode || loading">
            <svg *ngIf="loading" class="ck-spin" width="16" height="16" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" opacity="0.25"></circle><path fill="currentColor" opacity="0.75" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg>
            {{ loading ? 'Enregistrement...' : 'Enregistrer' }}
          </button>
        </div>
      </form>
    </div>
  </div>

  <div class="modal" [class.show]="showErrorModal">
    <div class="modal-content" style="border-top: 5px solid #e74c3c; text-align: center;">
      <div style="padding: 20px;">
        <i class="bi bi-shield-slash-fill" style="font-size: 3rem; color: #e74c3c;"></i>
        <h2 style="margin-top: 15px; color: #333;">Action impossible</h2>
        <p style="font-size: 1.1rem; color: #666; margin: 20px 0;">{{ serverErrorMessage }}</p>
        <div class="form-actions" style="justify-content: center;">
          <button class="btn-primary" (click)="showErrorModal = false">J'ai compris</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal" [class.show]="showDetailsModal" *ngIf="selectedKid">
    <div class="modal-content details-modal">
      <span class="close-x" (click)="closeDetailsModal()">&times;</span>
      <div class="modal-header-custom">
        <h2>{{ selectedKid.displayName }}
          <span class="status {{ selectedKid.active ? 'active' : 'inactive' }}">
            {{ selectedKid.active ? 'Actif' : 'Inactif' }}
          </span>
        </h2>
        <p class="subtitle">Détails de la {{ selectedKid.mode | lowercase }}</p>
      </div>

      <div class="info-grid">
        <div class="info-card">
          <h3>Informations générales</h3>
          <div class="detail-item"><i class="bi bi-geo-alt"></i>
            <div><strong>Adresse</strong><span>{{ selectedKid.address || 'Non renseignée' }}</span></div>
          </div>
          <div class="detail-item"><i class="bi bi-gear"></i>
            <div><strong>Type</strong><span class="type-tag">{{ selectedKid.mode }}</span></div>
          </div>
        </div>
        <div class="info-card">
          <h3>Contact responsable</h3>
          <div class="detail-item"><i class="bi bi-person"></i>
            <div><strong>Nom</strong><span>{{ selectedKid.ownerFirstName || '---' }}</span></div>
          </div>
          <div class="detail-item"><i class="bi bi-envelope"></i>
            <div><strong>Email</strong><span>{{ selectedKid.ownerEmail || '---' }}</span></div>
          </div>
          <div class="detail-item"><i class="bi bi-telephone"></i>
            <div><strong>Téléphone</strong><span>{{ selectedKid.ownerPhone || '---' }}</span></div>
          </div>
        </div>
      </div>

      <div class="history-card">
  <h3>HISTORIQUE et activité</h3>
  <div class="stats-row" style="display: flex; flex-wrap: wrap; gap: 10px;">


    <div *ngFor="let titre of selectedKidTitres" class="stat-box purple">
  <i class="bi bi-ticket-perforated"></i>
  <div>
    <span>{{ titre.label }}</span>
    <strong>{{ titre.solde | number:'1.0-0' }} XOF</strong>
  </div>
</div>


   <div class="stat-box gray">
  <i class="bi bi-graph-up-arrow"></i>
  <div>
    <span>Total des transactions</span>
    <strong>{{ selectedKidTotal | number:'1.0-0' }} XOF</strong>
  </div>
</div>

  </div>
  <div class="activity-line"><i class="bi bi-clock"></i> Dernière activité : {{ selectedKid.lastActivity }}</div>
  <div class="activity-line"><i class="bi bi-calendar"></i> Date de Création : {{ selectedKid.createdAt }}</div>
</div>

      <div class="qr-section" *ngIf="selectedKid.qrCode">
        <div class="qr-placeholder">
          <img [src]="selectedKid.qrCode" alt="QR Code">
        </div>
        <p>ID unique : {{ selectedKid.customerId }}</p>
      </div>
    </div>
  </div>

    <div class="tp-card">
    <div class="tp-toolbar">
      <div class="tp-toolbar-left">
        <div class="tp-search">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><line x1="20" y1="20" x2="16.65" y2="16.65"></line></svg>
          <input type="text" placeholder="Rechercher par nom" [(ngModel)]="search" />
        </div>

        <select class="tp-select" [(ngModel)]="statusFilter">
          <option value="ALL">Tous les statuts</option>
          <option value="ACTIVE">Actif</option>
          <option value="INACTIVE">Inactif</option>
        </select>
      </div>

      
    </div>

    <div class="tp-table-wrap">
      <table class="tp-table">
        <thead>
          <tr>
            <th>Nom de la boutique</th>
            <th>Adresse</th>
            <th>Mode</th>
            <th>Date de création</th>
            <th>Statut</th>
            <th class="col-center">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let kid of filteredKids()" class="row-clickable" (click)="openDetails(kid)">
            <td class="tp-strong">{{ kid.displayName || '—' }}</td>
            <td class="tp-muted">{{ kid.address || '—' }}</td>
            <td><span class="tp-chip">{{ kid.mode }}</span></td>
            <td class="tp-muted">{{ kid.createdAt }}</td>
            <td>
              <span class="tp-badge" [class.tp-badge--success]="kid.active" [class.tp-badge--danger]="!kid.active">
                <svg *ngIf="kid.active" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                <svg *ngIf="!kid.active" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                {{ kid.active ? 'Actif' : 'Inactif' }}
              </span>
            </td>
            <td class="col-center actions" (click)="$event.stopPropagation()">
              <label class="switch">
                <input type="checkbox" [checked]="kid.active" (change)="toggleStatus(kid)" />
                <span class="slider"></span>
              </label>
            </td>
          </tr>

          <tr *ngIf="!filteredKids().length">
            <td colspan="6" class="tp-empty">Aucune boutique ou caisse trouvée.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="tp-footer">
      <span>{{ filteredKids().length }} sur {{ kids.length }} boutique(s) / caisse(s)</span>
    </div>
  </div>
</div>
